import styled from 'styled-components';

export const Container = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 70px;
  padding: 0 8px;
  background-color: #111;
  border-top: 1px solid #222;
  position: relative;
  z-index: 2;

  p {
    color: #fff;
    margin: 8px;
  }

  @media (max-width: 767px) {
    p {
      font-size: 14px;
    }
  }
`;
